import { Route } from 'react-router-dom';
import React, { useEffect, useRef } from 'react';
import LogRocket from 'logrocket';
import * as Sentry from '@sentry/browser';
import { useAuth0 } from './react-auth0-spa';

function ProtectedRoute({ component: Component, ...rest }) {
  const { loading, user, isAuthenticated, loginWithRedirect } = useAuth0();
  const identifiedRef = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || !user || identifiedRef.current) return;
    identifiedRef.current = true;

    if (import.meta.env.VITE_LOGROCKET) {
      LogRocket.identify(user.preferred_username);

      LogRocket.getSessionURL((sessionUrl) => {
        Sentry.configureScope((scope) => {
          scope.setExtra('sessionUrl', sessionUrl);
        });
      });
    }

    if (import.meta.env.VITE_SENTRY_DSN) {
      Sentry.configureScope((scope) => {
        scope.setUser({
          username: user.preferred_username,
          email: user.email,
        });
      });
    }
  }, [isAuthenticated, user]);

  if (loading) return null;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated) {
          return <Component {...props} />;
        }

        loginWithRedirect();

        return null;
      }}
    />
  );
}

export default ProtectedRoute;
